import { render, staticRenderFns } from "./AfterSale.vue?vue&type=template&id=526f3122&scoped=true"
import script from "./AfterSale.vue?vue&type=script&lang=ts"
export * from "./AfterSale.vue?vue&type=script&lang=ts"
import style0 from "./afterSale.css?vue&type=style&index=0&id=526f3122&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f3122",
  null
  
)

export default component.exports